import React, { useState } from 'react'
//Material-UI
import Grid from '@material-ui/core/Grid'
//DS
import CardDetalle from './CardDetalle'
const Detalle = (props) => {
  const [detalle, setDetalle] = useState(props.detalle || null)
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        {detalle.asesor !== null && <CardDetalle key={detalle.codigo} ticketDetalle={detalle} /> }
      </Grid>
      <Grid item xs={12} sm={6}>
        {detalle.asesor === null && <CardDetalle key={detalle.codigo} ticketDetalle={detalle} />}
      </Grid>
    </Grid>
  )
}

export default Detalle